/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { apiClient } from '@lib/api-client';

import {
	queryOptions,
	useQuery,
} from '@tanstack/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type UseMeasurabilityProjectOptions = {
	importId: string;
	queryConfig?: any;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const rollBackImport = (
	importId: string
): Promise<any> => {
	return apiClient.get(
		`/imports/rollback/${importId}`,
		{}
	);
};

export const rollBackImportQueryOptions = (
	importId: string
) => {
	return queryOptions({
		queryKey: ['rollback-import', importId],
		queryFn: () => {
			return rollBackImport(importId);
		},
		staleTime: 1000,
	});
};

/* -------------------------------------------------------------------------- */
/*                                    Hooks                                   */
/* -------------------------------------------------------------------------- */
export const useRollbackImport = ({
	importId,
	queryConfig,
}: UseMeasurabilityProjectOptions) => {
	const {
		data,
		isFetching,
		isFetched,
		isRefetching,
		isError,
		isLoading,
		isSuccess,
		error,
	} = useQuery({
		...rollBackImportQueryOptions(importId),
		...queryConfig,
	});

	return {
		data,
		isFetching,
		isFetched,
		isRefetching,
		isError,
		error,
		isLoading,
		isSuccess,
	};
};
